import { useGetIdentity, useTranslate } from "ra-core";

import { CreateSheet, type CreateSheetProps } from "../misc/CreateSheet";
import { CompanyInputs } from "./CompanyInputs";
import { withHttps } from "./companyModel";

export interface CompanyCreateSheetProps extends Pick<
  CreateSheetProps,
  "history" | "mutationOptions"
> {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const CompanyCreateSheet = ({
  open,
  onOpenChange,
  history,
  mutationOptions,
}: CompanyCreateSheetProps) => {
  const { identity } = useGetIdentity();
  const translate = useTranslate();
  return (
    <CreateSheet
      resource="companies"
      title={translate("resources.companies.page.create")}
      defaultValues={{ sales_id: identity?.id }}
      transform={withHttps}
      open={open}
      onOpenChange={onOpenChange}
      history={history}
      mutationOptions={mutationOptions}
    >
      <CompanyInputs />
    </CreateSheet>
  );
};
